// crm namespace — shared CRM chrome: buttons, pager, table, wizard, role gate, Phase-2 page shells.
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "common.apply": "Appliquer",
    "common.back": "Retour",
    "common.cancel": "Annuler",
    "common.clear": "Effacer",
    "common.close": "Fermer",
    "common.dismiss": "Masquer",
    "common.loadMore": "Voir plus",
    "common.retry": "Réessayer",
    "common.save": "Enregistrer",
    "common.send": "Envoyer",
    "merge.label": "Champs de fusion :",
    "pager.label": "Pages",
    "pager.next": "Page suivante",
    "pager.perPage": "{n} par page",
    "pager.previous": "Page précédente",
    "role.ownerOnlyBody": "Demandez au titulaire si quelque chose doit changer ici.",
    "role.ownerOnlyTitle": "Cette page est réservée au titulaire du cabinet",
    "shell.forms.empty": "Votre formulaire de contact vivra ici",
    "shell.forms.title": "Formulaires",
    "shell.packs.empty": "Vos forfaits de séances vivront ici",
    "shell.packs.title": "Forfaits",
    "shell.phase2": "Cet écran arrive avec la prochaine version du CRM.",
    "table.selectPage": "Sélectionner cette page",
    "table.selectRow": "Sélectionner le client",
    "tags.remove": "Retirer l'étiquette {tag}",
    "wizard.back": "Retour",
    "wizard.next": "Suivant",
    "wizard.progress": "Étapes de l'import",
    "wizard.stepChip": "{n} · {label}",
  },
  en: {
    "common.apply": "Apply",
    "common.back": "Back",
    "common.cancel": "Cancel",
    "common.clear": "Clear",
    "common.close": "Close",
    "common.dismiss": "Dismiss",
    "common.loadMore": "Load more",
    "common.retry": "Try again",
    "common.save": "Save",
    "common.send": "Send",
    "merge.label": "Merge fields:",
    "pager.label": "Pages",
    "pager.next": "Next page",
    "pager.perPage": "{n} per page",
    "pager.previous": "Previous page",
    "role.ownerOnlyBody": "Ask the owner if you need something changed here.",
    "role.ownerOnlyTitle": "This page is for the practice owner",
    "shell.forms.empty": "Your capture form will live here",
    "shell.forms.title": "Forms",
    "shell.packs.empty": "Your session packs will live here",
    "shell.packs.title": "Packs",
    "shell.phase2": "This screen arrives with the next CRM release.",
    "table.selectPage": "Select this page",
    "table.selectRow": "Select client",
    "tags.remove": "Remove tag {tag}",
    "wizard.back": "Back",
    "wizard.next": "Next",
    "wizard.progress": "Import steps",
    "wizard.stepChip": "{n} · {label}",
  },
  es: {
    "common.apply": "Aplicar",
    "common.back": "Volver",
    "common.cancel": "Cancelar",
    "common.clear": "Borrar",
    "common.close": "Cerrar",
    "common.dismiss": "Descartar",
    "common.loadMore": "Cargar más",
    "common.retry": "Reintentar",
    "common.save": "Guardar",
    "common.send": "Enviar",
    "merge.label": "Campos de combinación:",
    "pager.label": "Páginas",
    "pager.next": "Página siguiente",
    "pager.perPage": "{n} por página",
    "pager.previous": "Página anterior",
    "role.ownerOnlyBody": "Pide a la persona titular si necesitas cambiar algo aquí.",
    "role.ownerOnlyTitle": "Esta página es solo para la persona titular de la consulta",
    "shell.forms.empty": "Tu formulario de captación vivirá aquí",
    "shell.forms.title": "Formularios",
    "shell.packs.empty": "Tus bonos de sesiones vivirán aquí",
    "shell.packs.title": "Bonos",
    "shell.phase2": "Esta pantalla llega con la próxima versión del CRM.",
    "table.selectPage": "Seleccionar esta página",
    "table.selectRow": "Seleccionar cliente",
    "tags.remove": "Quitar la etiqueta {tag}",
    "wizard.back": "Atrás",
    "wizard.next": "Siguiente",
    "wizard.progress": "Pasos de la importación",
    "wizard.stepChip": "{n} · {label}",
  },
};
